import React, { ReactElement } from 'react';
import { MemoAnalyticsSectionInspections } from '../sections/AnalyticsSectionInspections';
import { MemoAnalyticsSectionIssues } from '../sections/AnalyticsSectionIssues';
import { MemoAnalyticsDashboardPresentational } from './presentational';

function AnalyticsDashboard(): ReactElement {
  return (
    <MemoAnalyticsDashboardPresentational
      issuesSection={<MemoAnalyticsSectionIssues />}
      inspectionsSection={<MemoAnalyticsSectionInspections />}
    />
  );
}

export const MemoAnalyticsDashboard = React.memo(AnalyticsDashboard);
